import Cookies from 'js-cookie';

const FLAG_KEY = 'user_identity_classification_enabled' as const;
const IDENTITY_CLASSIFICATION_COOKIE_NAME = 'fortune_identity_classification_enabled';

type FlagStore = Partial<Record<typeof FLAG_KEY, boolean>>;

const getFlagStore = (): FlagStore | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const windowWithFlags = window as unknown as { __fortuneFeatureFlags?: FlagStore };
  return windowWithFlags.__fortuneFeatureFlags ?? null;
};

export const isIdentityClassificationEnabled = (): boolean => {
  const store = getFlagStore();
  const fromStore = store?.[FLAG_KEY];
  if (fromStore !== undefined) {
    return Boolean(fromStore);
  }
  if (typeof window !== 'undefined') {
    const cookieValue = Cookies.get(IDENTITY_CLASSIFICATION_COOKIE_NAME);
    if (cookieValue === '1') {
      return true;
    }
    if (cookieValue === '0') {
      return false;
    }
  }
  return false;
};
